import { styled, css } from "styled-components";

export const LinkColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  flex-wrap: wrap;
  height: 100%;
  width: 100%;
  @media (min-width: 576px) {
    max-height: 880px;
  }
  @media (min-width: 992px) {
    max-height: 580px;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-size: 14px;
  color: ${({ theme }) => theme.colors.default[600]};
  font-weight: 600;
  max-width: 175px;
  text-wrap: wrap;
`;

export const SectionTitle = styled.div`
  font-size: 16px;
  color: ${({ theme }) => theme.colors.default.default};
`;
